import { makeStyles } from 'lib/components';

const useStyles = makeStyles((theme) => ({
  userMenu: {
    minWidth: 250,
  },
  settingsOnSide: {
    marginRight: theme.spacing(1),
  },
  settingsBelow: {
    marginTop: theme.spacing(0.3),
  },
  listItemIcon: {
    minWidth: theme.spacing(3.5),
  },
  popper: {
    zIndex: 10001,
  },
  signOutIcon: {
    width: '24px',
    height: '24px',
  },
  listStyle: {
    padding: 0,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
    '& a': {
      color: theme.evPalette.charcoal[900],
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      fontWeight: '400',
      textDecoration: 'none',
      width: '100%',
      height: '100%',
      padding: '19px 24px',
    },
    '&#signOut': {
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
      padding: '19px 24px',
      backgroundColor: theme.evPalette.salt[100],
      border: 'none',
      borderTop: '1px solid #C8CDD7',
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal[100],
      },
    },
  },
  menuLink: {
    padding: '13px 10px',
    gap: '10px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: theme.evPalette.ocean[600],
    fontSize: theme.typography.pxToRem(16),
    textDecoration: 'none',
    fontWeight: 400,
    '& >a': {
      width: '100%',
      color: theme.evPalette.ocean[600],
      fontSize: theme.typography.pxToRem(16),
      textDecoration: 'none',
    },
    '@media (min-width: 1024px)': {
      width: 'unset',
      padding: '14px 16px',
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '20px',
      textAlign: 'center',
      fontWeight: 600,
      color: theme.evPalette.charcoal[700],
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal[200],
      },
    },
    '& .supportIcon': {
      color: theme.evPalette.ocean[600],
    },
  },
}));

export default useStyles;
